<template>
    <div class="podcasts2-index">
        <admin-layout>
            <app-content-pane class="ml-3">
                <template #title>
                    <div class="px-4 pt-3">
                        <h1 id="title">{{ utils.titleize(module_title) }}</h1>
                        <p>
                            Spark empathy, open intelligent discussion, and drive students to become
                            changemakers by introducing them to real stories about relevant social
                            issues through our podcast episodes.
                        </p>
                    </div>
                    <hr>

                    <div class="actions px-4 d-flex flex-column flex-lg-row">

                        <div class="row w-70 w-lg-50">
                            <div class="col col-8">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col col-4 col-lg-2 pt-2"><b>Modules:</b></div>
                                        <div class="col col-8 col-lg-10">
                                            <select id="themes" v-model="filters.group_id" class="form-control" @change="setModuleTitle">
                                                <option :value="null">All</option>
                                                <option v-for="theme in themes" :value="theme.id">{{ utils.titleize(theme.name) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-4 align-right">
                                <div class="form-group">
                                    <input class="form-control" placeholder="Search" v-model="filters.q"/>
                                </div>
                            </div>                            
                        </div>


                        <div class="form-group ml-auto">
                            <inertia-link v-if="is_admin"
                                          :href="route('pc.create', {...global_url_params})"
                                            class="btn btn-primary d-flex align-items-center">
                                <img src="/images/icons/plus-circle-solid-light.svg" class="mr-1" alt="">
                                Create new Podcast
                            </inertia-link>
                        </div>
                    </div>
                    <hr class="my-0">

                </template>

                <section class="px-4 py-3">
                    <div class="podcast-list">
                        <div class="row">
                            <template v-for="(podcast, index) in filtered_podcasts">

                                <template v-if="index < 0">
                                    <div class="col-12 border-bottom mb-3" :key="podcast.shot_name">
                                        <!-- TODO: Use max-size instead of colums logic, use columns only for preview & description -->
                                        <div class="row align-items-center justify-content-center">
                                            <div class="col-md-7">
                                                <podcast-card :featured="true"
                                                              :podcast="podcast"
                                                              :show-download="false"
                                                              :open-in-modal="false"
                                                              :show-groups="is_admin"
                                                              :actions="podcastActions"
                                                              class="mb-4"/>
                                            </div>
                                            <div class="col-md-5">
                                                <h2 class="text-secondary mb-3">
                                                    Help Students to Build Empathy and Become Changemakers
                                                    With the Design for Change podcast
                                                </h2>
                                                <p>
                                                    If you are interested in building a unique experience for students,
                                                    you can start by choosing from the library of social cause podcasts.
                                                    Students build empathy around the selected topic by listening to
                                                    the podcast, each of which is under 10 minutes. Then, take action
                                                    by facilitating our Empathy Warmup exercises or starting a Change
                                                    Project.
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </template>

                                <template v-else>
                                    <div class="col-12 col-lg-4" :key="podcast.id">
                                        <podcast-card :podcast="podcast"
                                                      :open-in-modal="false"
                                                      :actions="podcastActions"
                                                      :show-groups="is_admin"
                                                      class="mb-4"/>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </section>
            </app-content-pane>
        </admin-layout>
    </div>


</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import PodcastCard from "@/Components/Podcast/PodcastCard";
import API from "@/API";
import utils from "@/mixins/utils";
import mixpanel from "mixpanel-browser";
import jQuery from "jquery";
export default {
    name: "Index",
    components: {
        PodcastCard,
        AppContentPane,
        AdminLayout
    },

    mixins: [utils],

    props: ['podcasts'],

    data(){
        return{

            groups: [],

            filters: {
                q: null,
                group_id: null,
            },

            podcastActions: {},
        }
    },


    computed: {

        themes(){
            return this.groups.filter(g => g.type === 'theme');
        },

        module_title() {
            if (this.module) {
                return this.module;
            } else {
                return 'Social Change Podcasts';
            }
        },

        filtered_podcasts(){
            return this.podcasts.filter((p) => {
                if( this.filters.q || this.filters.group_id ){

                    let match = true;

                    if( this.filters.q ){
                        const regex = new RegExp(this.filters.q, 'i');
                        match &&= regex.test(p.name);
                    }

                    if( this.filters.group_id ){
                        match &&= p.groups.filter(g => g.id === this.filters.group_id ).length > 0;
                    }
                    return match;

                }
                return true;
            });
        }
    },


    methods: {
        async fetchGroups(){
            this.groups = await API.groups.bulk({type: ['theme']});

            this.themes = this.groups.filter(g => g.type === 'theme');
            if (this.module) {
                this.themes.forEach((value, index) => {
                    if (value.name == this.module) {
                        this.filters.group_id = parseInt(value.id);
                        this.mixpanel.track('MODULE', this.module);
                        this.$forceUpdate();
                    }
                });
            }
        },

        async setModuleTitle() {
            if (jQuery('#themes option:selected').text() == 'All') {
                jQuery('#title').html('Social Change Podcasts');
            } else {
                jQuery('#title').html(jQuery('#themes option:selected').text());;
            }
        }
    },

    beforeMount() {
        this.module = new URL(location.href).searchParams.get('module');
        if( this.is_admin ){
            this.podcastActions['edit'] = {
                action: (podcast) => {
                    this.$inertia.visit(this.route('pc.edit', {podcast: podcast.id, ...this.global_url_params}))
                },
                class: 'btn-light',
                title: 'Edit'
            };
        }
        this.fetchGroups();
    },

    mounted() {
        this.setTitle( 'Podcasts' );
    }
}
</script>

<style lang="scss" scoped>

</style>
